import type { ColumnDef } from '@tanstack/react-table';
import saveAs from 'file-saver';
import { createListWorkbook, ListWorkbookOptions } from './workbook';

// Pages own their export hooks, permissions and buttons; this only writes the file.
export const saveListExcel = async (
  rows: any[] | undefined,
  columns: ColumnDef<any>[],
  fileName: string,
  orderColumn = false,
  options: ListWorkbookOptions = {},
) => {
  if (!Array.isArray(rows)) throw new Error('Không lấy được dữ liệu tải về');
  const workbook = createListWorkbook(rows, columns, orderColumn, options);
  const buffer = await workbook.xlsx.writeBuffer();
  const now = new Date();
  const time = now
    .toLocaleTimeString('vi-VN', { hour12: false })
    .replace(/:/g, '_');
  const date = now
    .toLocaleDateString('vi-VN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    .replace(/\//g, '_');
  saveAs(
    new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }),
    `${fileName}_${time}_${date}.xlsx`,
  );
};
